import { createFileRoute, redirect } from '@tanstack/react-router';

import { getExecutiveClientTrendingQueryOptions } from 'helpers/executiveClientTrending';
import { executiveClientPathParams } from 'helpers/executiveClientApi';

export const Route = createFileRoute(
  '/_private/_route/users/$userId/trending/',
)({
  beforeLoad: async ({ context, params }) => {
    const { queryClient } = context;
    const pTrendings = await queryClient.ensureQueryData(
      getExecutiveClientTrendingQueryOptions({
        path: executiveClientPathParams(params.userId),
      }),
    );

    const nextRecommendationId = pTrendings.recommendations[0]?.uuid;

    if (nextRecommendationId) {
      throw redirect({
        params: {
          recommendationId: nextRecommendationId,
          userId: params.userId,
        },
        replace: true,
        search: (search) => search,
        to: '/users/$userId/trending/$recommendationId',
      });
    }
  },
});
